import { Component } from "@angular/core";
import { BaseInsuranceComponent } from "../base/base.component";
import { NxAccordionModule } from "@aposin/ng-aquila/accordion";
import { ResultItemComponent } from "../../result-item/result-item.component";
import { TranslationComponent } from "../../translation/translation.component";

@Component({
  selector: "app-fleet-insurance",
  standalone: true,
  imports: [NxAccordionModule, ResultItemComponent, TranslationComponent],
  templateUrl: "./fleet-insurance.component.html",
  styleUrl: "./fleet-insurance.component.css",
})
export class FleetInsuranceComponent extends BaseInsuranceComponent {}
